<template>
    <div class="table-responsive">
        <table class="table table-dark table-sm" :class="$style.loop">
            <colgroup>
                <col width="1">
                <col width="1">
                <col>
                <col width="1">
                <col width="1">
                <col width="1">
            </colgroup>
            <thead>
                <tr>
                    <th>#</th>
                    <th><font-awesome-icon icon="shapes"></font-awesome-icon></th>
                    <th>
                        <font-awesome-icon icon="tag" class="th-icon"></font-awesome-icon>
                        <span class="th-text">{{ $t('system_name') }}</span>
                    </th>
                    <th>
                        <font-awesome-icon icon="sign-out-alt" class="th-icon"></font-awesome-icon>
                        <span class="th-text">{{ $t('sell') }}</span>
                    </th>
                    <th>
                        <font-awesome-icon icon="sign-in-alt" class="th-icon"></font-awesome-icon>
                        <span class="th-text">{{ $t('buy') }}</span>
                    </th>
                    <th>
                        <font-awesome-icon icon="signal" class="th-icon"></font-awesome-icon>
                        <span class="th-text">{{ $t('tier') }}</span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(system, index) in loop" :key="index">
                    <td>
                        {{ index + 1 }}
                    </td>
                    <td>
                        <font-awesome-icon
                            :icon="getEcoIcon(system.ecoSubType)"
                            :style="{ color: getEcoColor(system.ecoSubType) }"
                        ></font-awesome-icon>
                    </td>
                    <td>{{ system.name }}</td>
                    <td>{{ system.sell ? system.sell + '%' : 'n/a' }}</td>
                    <td>{{ system.buy ? system.buy + '%' : 'n/a' }}</td>
                    <td>
                        <!-- <font-awesome-icon icon="star" v-for="n in system.tier" :key="n"></font-awesome-icon> -->
                        {{ system.tier }}
                    </td>
                </tr>
                <tr v-if="loop" :class="$style.loopBack">
                    <td>
                        1
                    </td>
                    <td>
                        <font-awesome-icon
                            :icon="getEcoIcon(loop[0].ecoSubType)"
                            :style="{ color: getEcoColor(loop[0].ecoSubType) }"
                        ></font-awesome-icon>
                    </td>
                    <td>{{ loop[0].name }}</td>
                    <td>{{ loop[0].sell ? loop[0].sell + '%' : 'n/a' }}</td>
                    <td>{{ loop[0].buy ? loop[0].buy + '%' : 'n/a' }}</td>
                    <td>
                        <!-- <font-awesome-icon icon="star" v-for="n in loop[0].tier" :key="n"></font-awesome-icon> -->
                        {{ loop[0].tier }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import utils from '@/mixins/utils';
export default {
    props: {
        loop: Array
    },
    mixins: [utils]
};
</script>

<style module scoped lang="scss">
    .loop {
        margin-bottom: 1em;
    }

    .loop th,
    .loop td {
        padding: 0 0.5em;
        text-align: end;
        white-space: nowrap;
    }

    // .loop th:nth-child(1),
    // .loop td:nth-child(1) {
    //     min-width: 1em;
    // }

    .loop th:nth-child(3),
    .loop td:nth-child(3) {
        text-align: start;
    }

    .loopBack {
        opacity: 0.5;
    }
</style>
